import React, { PropsWithChildren, useEffect, useState } from 'react';

export const RerenderAfterHydration = ({ children }: Props) => {

    const [isClient, setClient] = useState(false);

    useEffect(() => {
        setClient(true);
    }, []);

    return (
        <React.Fragment key={isClient ? 'client' : 'server'}>
            {children}
        </React.Fragment>
    );
};

type Props = PropsWithChildren<Record<never, never>>;